import moment from "moment"
import {getQueryParam} from "../misc/utils"

export const VersorgungsuebersichtActions = ({
    getDataFromPointer,
    navigate,
    updateData,
    getDataFromBackend,
}) => {
    return {
        INIT_ZIELSCHEIBE: () => {},
        NAVIGATE_DETAIL: () => {
            navigate("/detail")
        },
        SET_RADIOGROUP_VERTRAG: ({value}) => {
            const natuerlichePerson = getDataFromPointer("/kunde")
            const geburtsjahr = moment(
                natuerlichePerson.geburtsdatum,
                "YYYY-MM-DD",
            )
            const eingegebenerZinssatz = 5

            const optionMap = {
                FRUEH: () => {
                    return {
                        art: "SPARVERTRAEGE",
                        wert: 0,
                        datumInformation: geburtsjahr
                            .add(6, "years")
                            .format("YYYY-MM-DD"),
                        sparRate: 10,
                        sparrateEnde: geburtsjahr
                            .add(12, "years")
                            .format("YYYY-MM-DD"),
                        zinssatz: eingegebenerZinssatz,
                        zahlweiseSparRate: "MONATLICH",
                        altersvorsorgeVerwerten: true,
                        vorgabeID: 123,
                    }
                },
                SECHSSECHSSIEBEN: () => {
                    const eingegebenerBetrag = 175
                    return {
                        art: "SPARVERTRAEGE",
                        wert: 0,
                        datumInformation: geburtsjahr
                            .add(18, "years")
                            .format("YYYY-MM-DD"),
                        sparRate: eingegebenerBetrag,
                        sparrateEnde: geburtsjahr
                            .add(48, "years")
                            .format("YYYY-MM-DD"),
                        zinssatz: eingegebenerZinssatz,
                        zahlweiseSparRate: "MONATLICH",
                        altersvorsorgeVerwerten: true,
                        vorgabeID: 123,
                    }
                },
            }
            const vertragList =
                value in optionMap ? [optionMap[value]()] : []
            updateData(vertragList, "/kunde/kapitalanlagenList")
        },
        INIT_VERSORGUNGSUEBERSICHT: () => {
            const initDataUrl = getQueryParam("initUrl")
            if (initDataUrl) {
                getDataFromBackend(
                    {
                        href: initDataUrl,
                        methods: ["GET"],
                    },
                    "/",
                )
                    .then((payload) =>
                        getDataFromBackend(
                            payload._links.loadPerson,
                            "/kundeNp",
                        ),
                    )
            }
        },
    }
}
